// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cu2-X","type":"styles_type__1FmYO","choices":"styles_choices__37FYq"};